// TODO: make sure these match the constants used in /scripts/bundleConfig.js
export const CDN_CONFIG_PATH = 'https://lightning.warnermediacdn.com/cdp/psm/schemas/video/qos/'
export const FILES_CDN = 'program-map.top-2.json device-map.json event-map.top-2.json config.json'
export const PSM_CONFIG_PATH = 'https://lightning.warnermediacdn.com/cdp/psm/brands'
export const DEFAULT_API_PATH = 'https://dev.video.wmcdp.io/v1/vid'
export const PSM_MGR_POLL_INTERVAL_MIN = '5'
export const INVALID_VALIDATOR_LABEL = 'psmClientInvalid:'
export const SCHEMA_VERSION_NUMBER = '1.1.5'
export const INITIAL_SCHEMA_VERSION_NUMBER = '0.0.0'
export const POLLING_VERSION_PARAM = 'psm_test_polling_version_override'
export const LOCALSTORAGE_ACTIVE_CONFIG_KEY = 'psmTelConfig'
export const DEFAULT_TIMER_INTERVAL = 30
export const ENDING_EVENTS_CONFIG = ['contentCompleted', 'contentEnded']
export const CLEAN_STREAMTYPE_CHECK_EVENTS = ["contentBeginning", "mediaStarting", "contentEnded"]
export const PSM_SDK_RN_VERSION = '3.0.0'
export const PSM_SDK_WEB_VERSION = '3.2.1'
export const LOCALSTORAGE_WMUKID_KEY = 'WMUKID';
